// extracted by mini-css-extract-plugin
export var drawerPaper = "_28-0";
export var itemImage = "_28-1";